import clsx from "clsx";
import { Link } from "react-router-dom";
import {ChangeEvent, SetStateAction, useEffect, useState} from "react";
import {useThreadItemQuery, useGetAllPostsQuery, useThreadsListQuery} from "../../features";
import { ApiInfo, PageTitle, Panel, Field, Button, TextLoader } from "../../ui";
import { Material } from "./material";
import s from "./materials.module.css";
import {ApiServices} from "../../services/api-services";
import CustomSelect from "../../ui/custom-select/custom-select";
import {convertToSelectorList} from "../../utils/convert-to-selector-list";
import Pagination from 'rc-pagination';

export function Materials() {
  const [searchString, setSearchString] = useState('')
  const [searchResponsible, setSearchResponsible] = useState('')
  const [searchIOGV, setSearchIOGV] = useState('');
  const [items, setItems] = useState<Array<any>>([]);
  const [filteredData, setFilteredData] = useState<Array<any>>([]);
  const [responsibleList, setResponsibleList] = useState<Array<{id: string, keyword: string}>>([]);
  const [responsibleListIsLoading, setResponsibleListIsLoading] = useState(true);
  const [iogvList, setIogvList] = useState<Array<{id: string, keyword: string}>>([]);
  const [iogvListIsLoading, setIogvListIsLoading] = useState(true);
  const [dataIsLoading, setDataIsLoading] = useState(true);
  const [current, setCurrent] = useState(1);
  const onPage = 10;

  //const queryData = useThreadsQuery("");
  const queryData = useThreadsListQuery({ start: current > 1 ? (current-1)*onPage : 0, limit: onPage, filter:{responsible: searchResponsible, iogv_id: searchIOGV, status: '', title: searchString} });
  const { data, isSuccess, isLoading, isError, error } = queryData;
  const allPosts = useGetAllPostsQuery({})
  const onChange = (page: SetStateAction<number>) => {
    setCurrent(page);
  };


  useEffect(() => {
    getAllData()
  }, [data])

  const getAllData = async () => {
    setDataIsLoading(true)
    if (data?.items) {
      let tempItems = []
      for (const item of data.items) {
        const itemResponse = await ApiServices.getThreadItem({ thread_id: item.id })
        if (itemResponse.data) {
          tempItems.push({
            ...item,
            details: itemResponse.data
          })
        }
      }
      setItems(tempItems)
    }
    setDataIsLoading(false)
  }

  useEffect(() => {
    if (items.length > 0) {
      setResponsibleList(convertToSelectorList([...data?.responsibles]?.sort().filter(word => !word.includes("test_user") && !word.includes("string"))))
      setIogvList(convertToSelectorList(data.iogvs))
      setResponsibleListIsLoading(false)
      setIogvListIsLoading(false)
    }
  }, [items])

  useEffect(() => {
    if (items) {
      let tempItems: any[] = items.filter((it: any) => it.details.thread_id !== 0)
      setFilteredData(tempItems)
    }
  }, [searchResponsible, searchIOGV, searchString, items])


  const searchHandle = (evt: ChangeEvent<HTMLInputElement>) => {
    setSearchString(evt.target.value)
  }


  return (
    <>
      <PageTitle>Готовые материалы</PageTitle>
      <Panel className={s.search} padding>
      <Field className={s.searchField} icon="search" onChange={searchHandle} value={searchString} placeholder="Введите название" />
        <div className={s.fieldList}>
          <div className={s.field}>
            <span>Ответственный</span>
            <CustomSelect
              items={responsibleList}
              isLoading={responsibleListIsLoading}
              onChange={(value) => {
                setSearchResponsible(String(value))
                setCurrent(1)
              }}
              value={searchResponsible}
              withSearch={true}
              isWide={true}
            />
          </div>
          <div className={s.field}>
            <span>ИОГВ</span>
            <CustomSelect
              items={iogvList}
              isLoading={iogvListIsLoading}
              onChange={(value) => {
                setSearchIOGV(String(value))
                setCurrent(1)
              }}
              value={searchIOGV}
              withSearch={true}
              isWide={true}
            />
          </div>
        </div>
        <span className={s.count}>
          Всего готовых материалов: {" "}
           {isLoading ? <TextLoader /> : allPosts.data?.length-2 ?? "–"}
        </span>
      </Panel>

      <ApiInfo isLoading={isLoading || dataIsLoading} isError={isError} error={error} />

      {isSuccess && (
        <>
        <div className={s.list}>
          {filteredData.map((item: any, index: number) => (
            <Material number={current > 1 ? (current-1)*onPage+(index + 1) : index + 1} {...item} key={item.id + index} />
          ))}
        </div>
        <Pagination
          onChange={onChange}
          current={current}
          total={data?.count-10}
          pageSize={onPage}
        />
      </>
      )}
    </>
  );
}
